import { useState, useEffect } from "react";
import styles from "./RangeSlider.module.css";

const RangeSlider = ({ min = 0, max = 5, defaultValue, setSelectedPrice }) => {
  const adjustedMax = Math.max(max, 5);
  const step = (adjustedMax - min) / 5;

  const [value, setValue] = useState(defaultValue ?? min);

  useEffect(() => {
    updateTrack();
  }, [value]);

  const updateTrack = () => {
    const percent = ((value - min) / (adjustedMax - min)) * 100;
    return `${percent}%`;
  };

  // Handle slider value change
  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    setSelectedPrice(newValue);
  };

  // Handle clicking on labels
  const handleLabelClick = (labelValue) => {
    setValue(labelValue);
    setSelectedPrice(labelValue);
  };

  const labels = Array.from({ length: 6 }, (_, i) =>
    Math.round(min + i * step)
  );

  return (
    <div className={styles.sliderContainer}>
      {/* Track to indicate selected range */}
      <div
        className={styles.sliderTrack}
        style={{ width: updateTrack() }}
      ></div>

      {/* Range input */}
      <input
        type="range"
        min={min}
        max={adjustedMax}
        step={step}
        value={value}
        onChange={handleChange}
        className={styles.rangeSlider}
      />

      {/* Price Labels */}
      <div className={styles.sliderValues}>
        {labels.map((label, index) => (
          <span key={index} onClick={() => handleLabelClick(label)}>
            ${label}
            {index === labels.length - 1 ? "+" : ""}
          </span>
        ))}
      </div>
    </div>
  );
};

export default RangeSlider;
